/**
 * Created by Ning Jiang on 12/6/2018.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TweenLite} from "gsap";
import {TombstoneGameConfig} from "../../TombstoneGameConfig";

export class ReelAttentionView extends BaseView {

    private _currentReelId:number;
    private _attention:TimelineSprite;
    private _layer:ScalableLayer;

    constructor() {
        super();
        this.reset();
    }

    protected initAnimations():void {
        this._attention = new TimelineSprite(GameResources.getTextures("reelAttention"));
        this._attention.blendMode = PIXI.BLEND_MODES.SCREEN;
        this._attention.anchor.set(0.5);
        this._attention.alpha = 0;

        this._layer = StageManager.getLayer(TombstoneGameConfig.instance.LAYERS.REEL_BACKGROUND.name);
    }

    public playNearWin(reelId:number):void {
        this._currentReelId = reelId;
        const positionX:number = GameConfig.instance.REEL_DISPLAY_POSITIONS[reelId][0] + GameConfig.instance.REEL_AREA_POS_X;
        const positionY:number = GameConfig.instance.REEL_DISPLAY_POSITIONS[3][1] + GameConfig.instance.SYMBOL_HEIGHT * 1.5 + GameConfig.instance.REEL_AREA_POS_Y;
        this._attention.position.set(positionX, positionY);
        this._attention.playLoop();
        this._layer.addChild(this._attention);
        TweenLite.to(this._attention, 0.2, {alpha : 1});
    }

    public stopNearWin(reelId:number):void {
        if(reelId != this._currentReelId) {
            debugger;
            throw new Error(`ReelAttentionView.stopNearWin(): try to stop reel ${reelId} when current id is ${this._currentReelId}`);
        }

        TweenLite.to(this._attention, 0.5, {alpha : 0, onComplete : () => this._attention.stopLoop()});
    }

    public reset():void {
        this._currentReelId = -1;
    }
}